import { OnbOptionType } from '@/pages/Onboarding/types';

import { LayoutDataType } from '../../types';

export const ETHNICITY_OPTIONS_FEMALE: OnbOptionType<
  LayoutDataType['ethnicity']
>[] = [
  { id: 'african', title: 'African' },
  { id: 'asian', title: 'Asian' },
  { id: 'european', title: 'European' },
  { id: 'arabian', title: 'Arabian' },
];

export const ETHNICITY_OPTIONS_MALE: OnbOptionType<
  LayoutDataType['ethnicity']
>[] = [
  { id: 'african', title: 'African' },
  { id: 'asian', title: 'Asian' },
  { id: 'european', title: 'European' },
  { id: 'latino', title: 'Latino' },
];
